module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie H2 is a html <code>&lt;h2&gt;</code> text element</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;H2&gt;Your title goes here&lt;/H2&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/H2/README.md
// module id = 353
// module chunks = 0